module.exports = __webpack_public_path__ + "fonts/843d2a4562e1fb28ff0763a82ff635fb.woff";